export default function() {
  return {
    user: {
      userDetails: {}
    },
    users: [],
    dataOverview: [],
    watchlists: [],
    loadingMessages: "",
    showCookieBox: false
  };
}
